"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sha256_nonNative = void 0;
const _256_1 = __importDefault(require("hash.js/lib/hash/sha/256"));
/**
 * isomorphic sha256
 * Uses a js implementation. TODO: find lib that uses WebCrypto in browser and node-crypto on server.
 * (note: sindresorhus/crypto-hash does this, but uses Crypto.subtle in browser, which requires https, local dev not https currently)
 * @param val
 */
function sha256_nonNative(val) {
    return _256_1.default().update(val).digest('hex');
}
exports.sha256_nonNative = sha256_nonNative;
//# sourceMappingURL=hash-util-non-native.js.map